<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">直播审核(小程序)</a>
          <i>></i>
          <a href="javascript:;"  class="cur-a">直播审核</a>
        </span>
      </div>
      <div class="framePage-body">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabsChange">
          <el-tab-pane label="待审核" name="first">
            <liveToBeReviewed :name="activeName" ref="first" />
          </el-tab-pane>
          <el-tab-pane label="已通过" name="second">
            <liveToBeReviewedPass :name="activeName" ref="second" />
          </el-tab-pane>
          <el-tab-pane label="已驳回" name="three">
            <liveToBeReviewedReject :name="activeName" ref="three" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import liveToBeReviewed from "@/views/miniApp/liveReview/liveToBeReviewed.vue";
import liveToBeReviewedPass from "@/views/miniApp/liveReview/liveToBeReviewedPass.vue";
import liveToBeReviewedReject from "@/views/miniApp/liveReview/liveToBeReviewedReject.vue";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "miniApp/liveReview",
  components: {
    liveToBeReviewed,
    liveToBeReviewedPass,
    liveToBeReviewedReject
  },
  mixins: [List],
  data() {
    return {
      activeName: ""
    };
  },
  created() {
    this.activeName = this.$route.query.active || "first";
    this.name = this.$route.query.name || "first";
  },
  mounted() {
  },
  methods: {
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName }
      });
    },
    tabsChange(e) {
      this.activeName = e.name;
      this.name = e.name;
      this.$refs[e.name].liveTitle = '';
      this.$refs[e.name].getData(-1);
    }
  },
  beforeRouteLeave: resetKeepAlive,
};
</script>
<style lang="less">
.qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 400px;
    height: 400px;
    background-color: #999; //设置白色背景色
  }
}
.searchBox {
  .el-icon-arrow-down:before {
    content: "\e6df" !important;
  }
}
</style>
